Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeViewDescriptorsSet = makeViewDescriptorsSet;
exports.makeViewsRefSet = makeViewsRefSet;
var _react = require("react");
var _core = require("./core");
var _worklet_4365650429626_init_data = {
    code: "function anonymous(descriptors){const{item}=this.__closure;const index=descriptors.findIndex(function(descriptor){return descriptor.tag===item.tag;});if(index!==-1){descriptors[index]=item;}else{descriptors.push(item);}return descriptors;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/ViewDescriptorsSet.ts",
    sourceMap: '{"version":3,"names":["anonymous","descriptors","item","__closure","index","findIndex","descriptor","tag","push"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/ViewDescriptorsSet.ts"],"mappings":"AAsBqC,QAAC,CAAAA,UAAAC,WAA8B,QAAAC,IAAA,OAAAC,SAAA,CAE5D,KAAM,CAAAC,KAAK,CAAGH,WAAW,CAACI,SAAS,CAChC,SAAAC,UAAU,QAAK,CAAAA,UAAU,CAACC,GAAG,GAAKL,IAAI,CAACK,GAC1C,GAAC,CACD,GAAIH,KAAK,GAAK,CAAC,CAAC,CAAE,CAChBH,WAAW,CAACG,KAAK,CAAC,CAAGF,IAAI,CAC3B,CAAC,IAAM,CACLD,WAAW,CAACO,IAAI,CAACN,IAAI,CAAC,CACxB,CACA,MAAO,CAAAD,WAAW,CACpB"}',
    version: "3.5.4"
};
var _worklet_6739515972732_init_data = {
    code: "function anonymous(descriptors){const{viewTag}=this.__closure;const index=descriptors.findIndex(function(descriptor){return descriptor.tag===viewTag;});if(index!==-1){descriptors.splice(index,1);}return descriptors;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/ViewDescriptorsSet.ts",
    sourceMap: '{"version":3,"names":["anonymous","descriptors","viewTag","__closure","index","findIndex","descriptor","tag","splice"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/ViewDescriptorsSet.ts"],"mappings":"AAqCqC,QAAC,CAAAA,UAAAC,WAA8B,QAAAC,OAAA,OAAAC,SAAA,CAE5D,KAAM,CAAAC,KAAK,CAAGH,WAAW,CAACI,SAAS,CAChC,SAAAC,UAAU,QAAK,CAAAA,UAAU,CAACC,GAAG,GAAKL,OACrC,GAAC,CACD,GAAIE,KAAK,GAAK,CAAC,CAAC,CAAE,CAChBH,WAAW,CAACO,MAAM,CAACJ,KAAK,CAAE,CAAC,CAAC,CAC9B,CACA,MAAO,CAAAH,WAAW,CACpB"}',
    version: "3.5.4"
};
function makeViewDescriptorsSet() {
    var sharableViewDescriptors = (0, _core.makeMutable)([]);
    var data = {
        sharableViewDescriptors: sharableViewDescriptors,
        add: function add(item) {
            sharableViewDescriptors.modify(function() {
                var _e = [
                    new global.Error(),
                    -2,
                    -27
                ];
                var anonymous = function anonymous(descriptors) {
                    var index = descriptors.findIndex(function(descriptor) {
                        return descriptor.tag === item.tag;
                    });
                    if (index !== -1) {
                        descriptors[index] = item;
                    } else {
                        descriptors.push(item);
                    }
                    return descriptors;
                };
                anonymous.__closure = {
                    item: item
                };
                anonymous.__initData = _worklet_4365650429626_init_data;
                anonymous.__workletHash = 4365650429626;
                anonymous.__stackDetails = _e;
                return anonymous;
            }());
        },
        remove: function remove(viewTag) {
            sharableViewDescriptors.modify(function() {
                var _e = [
                    new global.Error(),
                    -2,
                    -27
                ];
                var anonymous = function anonymous(descriptors) {
                    var index = descriptors.findIndex(function(descriptor) {
                        return descriptor.tag === viewTag;
                    });
                    if (index !== -1) {
                        descriptors.splice(index, 1);
                    }
                    return descriptors;
                };
                anonymous.__closure = {
                    viewTag: viewTag
                };
                anonymous.__initData = _worklet_6739515972732_init_data;
                anonymous.__workletHash = 6739515972732;
                anonymous.__stackDetails = _e;
                return anonymous;
            }());
        }
    };
    return data;
}
function makeViewsRefSet() {
    var ref = (0, _react.useRef)(null);
    if (ref.current === null) {
        var data = {
            items: new Set(),
            add: function add(item) {
                if (data.items.has(item)) return;
                data.items.add(item);
            },
            remove: function remove(item) {
                data.items.delete(item);
            }
        };
        ref.current = data;
    }
    return ref.current;
}
